import React from 'react';
import { designTokens } from '../../styles/design-tokens';
import { useTheme } from '../../context/ThemeContext';

export const Section: React.FC<{ title: string; tooltip?: string; children: React.ReactNode }> = ({ title, tooltip, children }) => {
  const { theme } = useTheme();
  return (
    <div style={{ marginBottom: '20px' }}>
      <div title={tooltip} style={{
        borderLeft: `3px solid ${designTokens.colors.brand}`,
        paddingLeft: '8px',
        fontSize: '11px', fontWeight: 600, color: theme.textSecondary,
        textTransform: 'uppercase', letterSpacing: '0.06em',
        marginBottom: '8px',
      }}>
        {title}
      </div>
      {children}
    </div>
  );
};

export const Field: React.FC<{ label: string; value: string | null | undefined }> = ({ label, value }) => {
  const { theme } = useTheme();
  if (!value) return null;
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', padding: '5px 0',
      borderBottom: `1px solid ${theme.borderLight}`,
    }}>
      <span style={{ fontSize: '13px', color: theme.textTertiary }}>{label}</span>
      <span style={{
        fontSize: '13px', fontWeight: 500, color: theme.text,
        fontFamily: designTokens.typography.fontFamily.mono,
      }}>{value}</span>
    </div>
  );
};
